module.exports = __webpack_public_path__ + "static/cha2-d231edf03b6c1fd8d3632432a3211f08.gif";